interface AccordionItem {
  question: string;
  answer: string;
}

interface AccordionProps {
  title?: string;
  items?: AccordionItem[];
}

export function AccordionBlock({ props }: { props: AccordionProps }) {
  const items = props.items ?? [];
  if (items.length === 0) return null;

  return (
    <div className="py-6 px-4">
      {props.title && (
        <h2 className="text-xl font-bold text-zinc-900 mb-4">{props.title}</h2>
      )}
      <div className="flex flex-col divide-y divide-zinc-100 border border-zinc-100 rounded-xl overflow-hidden">
        {items.map((item, i) => (
          <details key={i} className="group">
            <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none select-none bg-white hover:bg-zinc-50 transition-colors">
              <span className="font-medium text-zinc-800 text-sm">{item.question}</span>
              <svg
                className="w-4 h-4 flex-shrink-0 text-zinc-400 transition-transform group-open:rotate-180"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </summary>
            <div className="px-5 py-4 text-sm text-zinc-600 leading-relaxed bg-white border-t border-zinc-50">
              {item.answer}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
